import { BasicParametersSubForm } from './BasicParametersSubForm';
import { QueueSubForm } from './QueueSubForm';
import { StreamDataSubForm } from './StreamDataSubForm';

export const SubForms = {
  BasicParametersSubForm,
  StreamDataSubForm,
  QueueSubForm,
};
